import Select from '@r1-frontend/ui-react/components/select/select';
import Tab from '@r1-frontend/ui-react/components/tabs/tab';
import Tabs from '@r1-frontend/ui-react/components/tabs/tabs';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ContactList } from '~/src/components/ContactList';
import { prepareMapOptions, YandexMap } from '~/src/components/YandexMap';
import NoSSR from '~/src/helpers/noSSR';
import { selectCompanyName } from '~/src/store/selectors/city';

import * as ST from './styled';

const categoryAll = {
    value: 'all',
    label: 'Все категории',
};

class Wifi extends Component {
    static propTypes = {
        contacts: PropTypes.array,
        wifiPoints: PropTypes.array,
        city: PropTypes.object,
        isAuth: PropTypes.bool,
    };

    static defaultProps = {
        contacts: [],
        city: {},
        wifiPoints: [],
    };

    constructor(props) {
        super(props);
        this.mapInstance = React.createRef();
        this.mapWrapRef = React.createRef();
        this.mapPoints = prepareMapOptions(this.props.wifiPoints);
        this.pointsOptions = [];//* ** */
        this.сategoryOptions = [categoryAll];
        this.prepareSelectOptions(this.props.wifiPoints);

        this.state = {
            isOnlyDomru: false,
            selectedContact: null,
            selectedCategory: categoryAll,
            filteredSelectOptions: this.pointsOptions,
            filteredMapPoints: this.mapPoints,
        };
    }

    prepareSelectOptions(wifiPoints) {
        if (Array.isArray(wifiPoints)) {
            const categoriesSet = new Set();
            wifiPoints.forEach(item => {
                const { pid, address, type, hotspot_type } = item;
                this.pointsOptions.push({
                    value: pid,
                    label: address,
                    contactType: type,
                    category: hotspot_type,
                });
                categoriesSet.add(hotspot_type);
            });

            categoriesSet.forEach(value => {
                this.сategoryOptions.push({
                    value: value,
                    label: value,
                });
            });
        }
    }

    onChangeContact = (elem) => {
        const { selectedCategory } = this.state;
        const mapPointsByCategory = this.filterPointsByCategory(this.mapPoints, selectedCategory);
        this.setState({
            selectedContact: elem,
            filteredMapPoints: this.filterPointsBySelect(mapPointsByCategory, elem),
        });
    };

    onChangeCategory = (category) => {
        this.setState({
            selectedCategory: category,
            filteredMapPoints: this.filterPointsByCategory(this.mapPoints, category),
            filteredSelectOptions: this.filterPointsByCategory(this.pointsOptions, category),
        });
    };

    filterPointsBySelect(list, selectedContact) {
        const selectedPoints = selectedContact ? list.find(item => item.id === selectedContact.value) : undefined;
        return selectedPoints ? [selectedPoints] : list;
    }

    filterPointsByCategory(list, category) {
        if (category === categoryAll) {
            return list;
        } else {
            return list.filter(item => item.category === category.value);
        }
    }

    renderTabs = () => {
        return (
            <Tabs>
                <Tab label='Как абонент'>
                    <ST.DescText>При входе как Абонент введите номер договора и пароль от Личного кабинета, затем нажмите на кнопку «Войти».</ST.DescText>
                </Tab>
                <Tab label='Как гость'>
                    <ST.DescText>
                        При входе как Гость вам может потребоваться СМС-код.
                        Для этого укажите номер своего телефона и нажмите на кнопку «Получить СМС-код».
                        Полученный код введите в поле ниже и нажмите на кнопку «Войти».
                    </ST.DescText>
                </Tab>
            </Tabs>
        );
    };

    render() {
        const { selectedContact, selectedCategory, filteredMapPoints, filteredSelectOptions } = this.state;
        const { city, companyName, isAuth } = this.props;

        return (
            <ST.Wifi>
                <ST.Head>
                    <ST.InnerContainer>
                        <ST.Title isLight={true}>Беспроводной интернет {companyName} Wi-Fi в {city?.cityIn}</ST.Title>
                        <ST.DescElemWifi>
                            <ST.DescTitle>Wi-Fi всегда рядом</ST.DescTitle>
                            <ST.DescText isLight={true}>Найти ближайшую Wi-Fi зону проще простого!
                                Используйте карту локаций на&nbsp;сайте dom.ru.
                            </ST.DescText>
                        </ST.DescElemWifi>
                        <ST.DescElemInternet>
                            <ST.DescTitle>Бесплатный доступ в интернет</ST.DescTitle>
                            <ST.DescText isLight={true}>
                                Любимые сайты, социальные сети, онлайн-видео на высокой скорости и абсолютно
                                бесплатно – везде, где есть {companyName} Wi-Fi.
                            </ST.DescText>
                            <Link href={isAuth ? '/lk/internet/speedup' : '/speedup'} passHref>
                                <ST.DescLink>Мультимедиа ресурсы</ST.DescLink>
                            </Link>
                        </ST.DescElemInternet>
                    </ST.InnerContainer>
                </ST.Head>

                <ST.FilterWrap>
                    <ST.InnerContainer>
                        <ST.Title as='h2'>Одна из&nbsp;крупнейших городских Wi-Fi сетей интернета в&nbsp;регионах</ST.Title>
                        <ST.DescText>
                            Провайдер {companyName} построил уже более 26&nbsp;000 Wi-Fi зон в&nbsp;36&nbsp;регионах России,
                            пользуйтесь бесплатным Wi-Fi в&nbsp;любимом кафе или ожидая сеанса в&nbsp;кинотеатре.
                        </ST.DescText>
                        <NoSSR>
                            <ST.SelectWrap>
                                <Select
                                    options={filteredSelectOptions}
                                    value={selectedContact}
                                    isSearchable={true}
                                    isClearable={true}
                                    onChange={this.onChangeContact}
                                    placeholder='Поиск по адресам'
                                    noOptionsMessage={()=>'нет совпадений'}
                                    styles={ST.customStylesSelect(true)}
                                />
                            </ST.SelectWrap>
                            <ST.SelectWrap>
                                <Select
                                    options={this.сategoryOptions}
                                    value={selectedCategory}
                                    isSearchable={true}
                                    isClearable={false}
                                    onChange={this.onChangeCategory}
                                    placeholder='Категории'
                                    noOptionsMessage={()=>'нет совпадений'}
                                    styles={ST.customStylesSelect(false)}
                                />
                            </ST.SelectWrap>
                        </NoSSR>
                    </ST.InnerContainer>
                </ST.FilterWrap>

                <ST.MapWrap ref={this.mapWrapRef}>
                    <NoSSR>
                        <YandexMap ref={this.mapInstance} points={filteredMapPoints} />
                    </NoSSR>
                </ST.MapWrap>

                <ST.InnerContainer>
                    <ST.ContactsWrap>
                        <ContactList contacts={filteredMapPoints} />
                    </ST.ContactsWrap>
                </ST.InnerContainer>

                <ST.InnerContainer>
                    <ST.Title as='h2'>Как подключиться к&nbsp;{companyName} Wi-Fi и&nbsp;получить бесплатный доступ к&nbsp;интернету?</ST.Title>
                    <ST.DescText>Авторизуйтесь, как абонент {companyName}. Или войдите, как гость.</ST.DescText>
                    <ST.GuideName>Как это сделать?</ST.GuideName>
                    <ST.Guide>
                        <ST.GuideElem>
                            <ST.GuideNum>1</ST.GuideNum>
                            <ST.GuideTitle>Включите модуль Wi-Fi</ST.GuideTitle>
                            <ST.DescText>Выберите из списка доступных сетей {companyName} Wi-Fi и подключитесь к ней</ST.DescText>
                        </ST.GuideElem>
                        <ST.GuideElem>
                            <ST.GuideNum>2</ST.GuideNum>
                            <ST.GuideTitle>Откройте в браузере любой сайт</ST.GuideTitle>
                            <ST.DescText>На открывшемся портале авторизации выберите одну из двух опций входа – как Абонент {companyName} или как Гость</ST.DescText>
                        </ST.GuideElem>
                        <ST.GuideElem>
                            <ST.GuideNum>3</ST.GuideNum>
                            {this.renderTabs()}
                        </ST.GuideElem>
                    </ST.Guide>
                </ST.InnerContainer>

                <ST.InnerContainer>
                    <ST.Title as='h2'>У вас свой бизнес? У нас есть предложение для вас!</ST.Title>
                    <ST.DescText>Установите у себя бесплатную точку доступа {companyName} — увеличьте посещаемость своего заведения.</ST.DescText>
                    <ST.DescLink href={`https://${city?.domain === 'interzet' ? 'spb' : city?.domain}.b2b.dom.ru/products/wi-fi-hot-spot`} isDark={true}>
                        Узнайте подробности
                    </ST.DescLink>
                </ST.InnerContainer>
            </ST.Wifi>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    wifiPoints: state.wifi.items,
    companyName: selectCompanyName(state),
    isAuth: state.auth.isAuth,
});

export default connect(mapStateToProps)(Wifi);
